import { Paper } from "@material-ui/core";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EColourPanel from "../../interfaces/EColourPanel";
import IVenue from "../../interfaces/IVenue";
import { uploadFileToS3 } from '../../services/s3Controller';
import { useAuthenticationContext } from "../../yoello-lib/modules/auth/AuthenticationContext"
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import DynamicForm from "../../yoello-lib/modules/dynamicForms/DynamicForms";
import FormImageManipulator from "../../yoello-lib/modules/components/ImageManipulator/FormImageManipulator";
import ListLoading from "../util/Loading";
import useTask from "../../hooks/useTask";
import { useSnackbarMessages } from "../../yoello-lib/modules/components/snackbar/SnackbarContext";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import Styles from "../../scss/venueImages.module.scss";
import { useAPIV2 } from '../../yoello-lib/modules/API2/useAPIv2';
import APIExtensions from '../../yoello-lib/modules/API2/APIDefs';
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../const/permissions.const";

interface IProfileVenueImages{
    groupId?:string;
}

export function ProfileVenueImages({ groupId }:IProfileVenueImages) {
    const [imgURLs, setimgURLs] = useState<{ logo?: string, banner?: string } | undefined>(undefined);
    const [logoLoading, setLogoLoading] = useState(false);
    const [logo, setIsLogoSelected] = useState(false);
    const [bannerLoading, setBannerLoading] = useState(false);
    const [banner, setIsBannerSelected] = useState(false);
    const { t } = useTranslation();
    const { increaseDoneTasks } = useTask();
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { retrieveAccessToken } = useAuthenticationContext();
    const { callAPI: updateVenueDetails } = useAPIV2<IVenue[]>(APIExtensions.venues, { query: selectedVenueId, onMountDisabled: true, successCall:t("snackbar.updateSuccess"),
    successCallMethods: [HTTPMethods.PUT] });

    const { sendSnackbarMessage } = useSnackbarMessages()!;

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.VENUE_MANAGEMENT);

    const { apiData: venue } = useAPIV2<IVenue>(APIExtensions.venues, {
        selectorKeyParams: { venue_id: selectedVenueId },
        canAPIGetCacheValue: true,
        query: selectedVenueId,
        dispatcherParams: [selectedVenueId],
    });

    useEffect(() => {
        if (venue && imgURLs === undefined) {
            const imgObj = {
                banner: venue.url_banner,
                logo: venue.url_logo
            };
            setimgURLs(imgObj);
        }
        //eslint-disable-next-line
    }, [venue]);
    const logoFormOnSunmit = async (data: Record<string, any>) => {
        if (typeof data["logo"] === 'string' && data["logo"] !== "delete") {
            return;
        }

        setLogoLoading(true);
        try {
            const uploadImg = await uploadFileToS3(data["logo"], retrieveAccessToken, venue?.id! + "/promotional/");
            if (uploadImg !== undefined) {
                await updateVenueDetails(HTTPMethods.PUT, { body: { url_logo: uploadImg.url } });
                setimgURLs(prevState => ({
                    ...prevState,
                    logo: uploadImg.url
                }));
            }
        } catch (e) {
            sendSnackbarMessage(t('errors.formerrors.saveImage'), "error");
        }
        setLogoLoading(false);
        setIsLogoSelected(false)
        increaseDoneTasks();

    };
    const bannerFormOnSunmit = async (data: Record<string, any>) => {
        if (typeof data["banner"] === 'string' && data["banner"] !== "delete") {
            return;
        }

        setBannerLoading(true);
        try {
            const uploadImg = await uploadFileToS3(data["banner"], retrieveAccessToken, venue?.id! + "/promotional/");
            if (uploadImg !== undefined) {
                await updateVenueDetails(HTTPMethods.PUT, { body: { url_banner: uploadImg.url } });
                setimgURLs(prevState => ({
                    ...prevState,
                    banner: uploadImg.url
                }));
            }
        } catch (e) {
            sendSnackbarMessage(t('errors.formerrors.saveImage'), "error");
        }
        setBannerLoading(false);
        setIsBannerSelected(false);
        increaseDoneTasks();
    };
    function onSelectBanner() {
        setIsBannerSelected(true);
    }
    function onSelectLogo() {
        setIsLogoSelected(true);
    }
    return <>
        <Paper className={Styles.profileLogoContainer}>
            {logoLoading ? <ListLoading /> :
                <DynamicForm 
                    onHandleSubmit={logoFormOnSunmit} 
                    formData={{ logo: imgURLs?.logo || undefined }} 
                    formKeyName={"logo"} 
                    disableAll={!hasPermission}
                    disableAllInteraction={onFailedInteraction}
                    formRows={[{
                        keyName: "logo",
                        label: "imageUploader.logo",
                        Component: FormImageManipulator,
                        formProps: {
                            typeOfFile: "logo",
                            crop: { unit: "px", aspect: 1 / 1, width: 50, height: 50 },
                            onValueChange: onSelectLogo,
                            hasDelete: true,
                        }
                    }]}
                    formButtons={{
                        rightButton: logo ? { type: 'submit', label: 'imageUploader.submit', color: EColourPanel.PRIMARY,style:{
                            marginRight:"auto"
                        } } : undefined
                    }} 
                />
            }
        </Paper>
       { !groupId && <Paper className={Styles.profileBannerContainer} >
            {bannerLoading ? <ListLoading /> :
                <DynamicForm 
                    onHandleSubmit={bannerFormOnSunmit} 
                    formData={imgURLs} 
                    formKeyName={"banner"}
                    disableAll={!hasPermission}
                    disableAllInteraction={onFailedInteraction}
                    formRows={[{
                        keyName: "banner",
                        label: "imageUploader.banner",
                        Component: FormImageManipulator,
                        formProps: {
                            typeOfFile: "banner",
                            required: true, crop: { unit: "px", aspect: 5 / 3, width: 125, height: 75 },
                            onValueChange: onSelectBanner,
                            hasDelete: true,
                            maxWidth:768
                        }
                    }]} 
                    formButtons={{
                        rightButton: banner ? { type: 'submit', label: 'imageUploader.submit', color: EColourPanel.PRIMARY,style:{
                            marginRight:"auto"
                        }  } : undefined
                    }} 
                />
            }
        </Paper>}
    </>
}